class DeployerQuantity extends HTMLElement {
  constructor() {
    super();
    this.main_product_section_id = this.dataset.sectionId;

    // update when variant changes
    this.variantChangeSubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event.data.mainProductPage) {
        this.renderDeployerQuantityBreaks(event.data.variant);
      }
    });
  }

  connectedCallback() {
    // update when quantity offer changes
    this.querySelectorAll(".variantButton_offre").forEach((offre) => {
      offre.addEventListener("click", () => {
        this.selectQuantity(offre);
      });
    });
  }

  selectQuantity(offre) {
    if (offre.classList.contains("variantButton_offre-disabled")) return;
    this.resetSelectedQuantity();
    offre.classList.add("variantButton_offre-selected");
    this.updateFormInputs(offre);
  }

  selectNextAvailableOffer() {
    if (this.getSelectedOffer().classList.contains("variantButton_offre-disabled")) {
      for (let i = 0; i < this.querySelectorAll(".variantButton_offre").length; i++) {
        if (!this.querySelectorAll(".variantButton_offre")[i].classList.contains("variantButton_offre-disabled")) {
          this.selectQuantity(this.querySelectorAll(".variantButton_offre")[i]);
          break;
        }
      }
    }
  }

  resetSelectedQuantity() {
    this.querySelectorAll(".variantButton_offre").forEach((offre) => {
      offre.classList.remove("variantButton_offre-selected");
    });
  }

  updateAvailableQuantityOffers() {
    const klaviyoContainer = document.querySelector(".klaviyo-bis-trigger");
    var bisTriggerValue;

    this.querySelectorAll(".variantButton_offre").forEach((offre) => {
      if (this.getCurrentVariantType() == "mix") {
        offre.classList.remove("variantButton_offre-disabled");
        if(klaviyoContainer) {
          klaviyoContainer.classList.add("tr-hidden");
          bisTriggerValue = 'none'
        }

        //si il n'y a pas de mix associée à cette variante, on désactive l'offre
        if (offre.querySelector(".deployer-quantity-input-data") == null || offre.querySelector(".deployer-quantity-input-data").innerHTML.trim() == "") {
          offre.classList.add("variantButton_offre-disabled");
        } else {
          //si il y a un mix associé mais qu'une des variantes est en rupture de stock, on désactive l'offre
          if (offre.querySelector(".deployer-quantity-input-data .one-variant-is-out-of-stock") != null) {
            offre.classList.add("variantButton_offre-disabled");
            if(klaviyoContainer) {
              klaviyoContainer.classList.remove("tr-hidden");
              bisTriggerValue = 'block'
            }
          }
        }
      }
    });
    if (klaviyoContainer) {
      klaviyoContainer.style.display = bisTriggerValue;
    }
    return bisTriggerValue;
  }

  renderDeployerQuantityBreaks(variant) {
    this.classList.add("loading");
    this.resetSelectedQuantity();
    var variant_param = "?variant=" + variant.id + "&";
    if (variant.id === undefined) variant_param = "?";

    fetch(window.location.pathname + variant_param + "section_id=" + this.main_product_section_id)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const deployerQuantityBreaksSource = html.querySelector("deployer-quantity");
        const deployerQuantityBreaksDestination = document.querySelector("deployer-quantity");

        if (deployerQuantityBreaksSource && deployerQuantityBreaksDestination) {
          deployerQuantityBreaksDestination.innerHTML = deployerQuantityBreaksSource.innerHTML;
          deployerQuantityBreaksDestination.connectedCallback();
        }
      })
      .then(() => {
        this.updateAvailableQuantityOffers();
        this.selectNextAvailableOffer();
        this.updateMainPrice();
        this.updateMainAtcButton();
        this.updateFormInputs(this.getSelectedOffer());
        this.classList.remove("loading");
      });
  }

  updateFormInputs(offre) {
    //reset des inputs injectés
    document.querySelectorAll(".product-form .input-mix").forEach((input) => {
      input.remove();
    });

    if (this.getCurrentVariantType() == "mix") {
      document.querySelector("#main-product-form-quantity").disabled = true;
      document.querySelector("#main-product-form-id").disabled = true;
      if (this.getSelectedOffer().querySelector(".deployer-quantity-input-data") != null && this.getSelectedOffer().querySelector(".deployer-quantity-input-data").innerHTML != "") {
        document.querySelector("#main-product-form-id").insertAdjacentHTML("afterend", this.getSelectedOffer().querySelector(".deployer-quantity-input-data").innerHTML);
      }
    } else {
      document.querySelector("#main-product-form-quantity").disabled = false;
      document.querySelector("#main-product-form-id").disabled = false;
      document.querySelector("#main-product-form-quantity").value = offre.dataset.quantity;
    }
  }

  updateMainAtcButton() {
    const addButton = document.querySelector(".product__info-container .product-form button[name='add']");
    const addButtonText = addButton.querySelector("span");

    if (this.getSelectedOffer().classList.contains("variantButton_offre-disabled")) {
      addButton.disabled = true;
      addButtonText.innerHTML = window.variantStrings.soldOut;
    } else {
      addButton.disabled = false;

      // Vérifier si c'est une précommande avant de définir le texte
      const template = document.querySelector("variant-radios template");
      let isPreorder = false;

      if (template) {
        const options = template.content.querySelectorAll("option");
        const currentVariantId = addButton.closest("form").querySelector('[name="id"]').value;

        options.forEach((option) => {
          if (option.value == currentVariantId && option.dataset.preorderDate != undefined) {
            isPreorder = true;
          }
        });
      }

      if (isPreorder) {
        addButtonText.innerHTML = window.variantStrings.addToCart;
      } else {
        addButtonText.innerHTML = window.variantStrings.addToCart;
      }
    }
  }

  updateMainPrice() {
    const price = this.getSelectedOffer().querySelector(".variantButton_offre-price_text:not(.variantButton_offre-compare-price_text)").innerHTML;
    document.querySelector(".product__info-container .price__container .price__regular .price-item--regular").innerHTML = price;

    if (this.getSelectedOffer().querySelector(".variantButton_offre-compare-price_text") != null) {
      const compare_at_price = this.getSelectedOffer().querySelector(".variantButton_offre-compare-price_text").innerHTML;
      document.querySelector(".product__info-container .price__container .price__sale .--price-item--sale").innerHTML = price;
      document.querySelector(".product__info-container .price__container .price__sale .--price-item--regular").innerHTML = compare_at_price;
      document.querySelector(".product__info-container .price-container > .price").classList.add("price--on-sale");
    } else {
      document.querySelector(".product__info-container .price-container > .price").classList.remove("price--on-sale");
    }
  }

  getSelectedOffer() {
    return this.querySelector(".variantButton_offre-selected");
  }

  getSelectedVariant() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return parseInt(urlParams.get("variant"));
  }

  getCurrentVariantType() {
    if (this.querySelector(".variant_group").dataset.isCurrentVariantAMix == "false") return "classic";
    if (this.querySelector(".variant_group").dataset.isCurrentVariantAMix == "true") return "mix";
    return "classic";
  }
}

customElements.define("deployer-quantity", DeployerQuantity);
